import { PreApprovedType } from "./preApprovedType";

export default class PreApprovedValue {
    constructor(
        public id = '',
        public amount = 0,
        public type: PreApprovedType = new PreApprovedType(''),
        public createdAt = 0
    ) {}
}